import React, { useState } from 'react'
import Constants from 'EurestoFonction/Constants'

import Formulaire from 'Components/Formulaire'
import Template from '../../Component/Media/'
import User from 'EurestoClass/User'
import { Grid } from '@material-ui/core'
import Avatar from 'Components/Avatar'

import Search from '../../Component/Search'

import { usePersistFn } from 'ahooks'
import moment from 'moment'

const columns = [{
    header: 'Id',
    id: 'id',
    show: false,
}, {
    id: 'lien',
    header: null,
    sortable: false,
    width: 30,
    type: 'string',
    Cell: (row) => {
        return (
            <div style={{ position: 'relative' }}>
                <Avatar
                    type={'contact'}
                    src={row.lien}
                    style={{ width: '45px', height: '45px', padding: 5 }} />
            </div>
        )
    },
}, {
    id: 'libelle',
    header: 'Nom',
    type: 'string'
}, {
    id: 'type_media_id',
    width: 80,
    header: 'Type',
    type: 'string',
    Cell: row => {
        const typeFichier = Constants.usefullObjectStatic[Constants.module.COMMUN + '-' + Constants.donnee.media].type.find(type => type.id === row.type_media_id)
        return typeFichier ? typeFichier.libelle : ''
    }
}, {
    id: 'type_fichier',
    width: 30,
    header: 'MIME',
    type: 'string'
}, {
    id: 'date_creation',
    width: 150,
    header: 'Date',
    type: 'string',
    Cell: row => {
        return moment(row.date_creation).format('DD/MM/YY HH:mm')
    }
}]

const defaultObject = {
    libelle: '',
    type_media_id: 99,
}

const isAllow = {
    add: true, update: false, delete: true
}

const formStyle = { padding: 0 }

const setAllow = (row) => isAllow

export default React.memo(props => {

    return <React.Fragment>
        <Formulaire
            doNotHandleWs={true}
            config={props.config}
            infinityScroll={true}
            showSearchComponent={props.showSearch}
            isAllow={isAllow}
            searchComponent={props.showSearch && <Search unsave={props.unsave} raz showAsEntity={props.showAsEntity} defaultSearch={props.defaultSearch}/>}
            formStyle={formStyle}
            setAllow={setAllow}
            search={props.search || 'media_' + (props.name || '') + User.Entite.get().id}
            title={EurestoI18n.t('commun:Media')} form={<Template showAsEntity={props.showAsEntity} />}
            module={Constants.module.COMMUN}
            requete={Constants.donnee.media} 
            columns={columns} />
    </React.Fragment>
})


// WEBPACK FOOTER //
// ./app/App/Module/Media/Page/Recherche/index.js